import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map, mergeMap, of } from 'rxjs';
import { AgentsApi } from 'src/lib/repository/agents/agents.api';
import { BookingApi } from 'src/lib/repository/booking/booking.api';
import { IBooking } from 'src/lib/repository/booking/booking.model';

export const bookingDetailDocumentResolver: ResolveFn<IBooking> = (route) => {
  const bookingApi = inject(BookingApi);
  const agentsApi = inject(AgentsApi);

  return bookingApi.findItem(route.params['id']).pipe(
    mergeMap((booking) => {
      if (booking.agentId) {
        return agentsApi.findItem(booking.agentId).pipe(
          map((agent) => {
            booking.agentName = agent.name;
            booking.agentPhone = agent.phone;
            booking.agentFax = agent.fax;
            booking.agentAddress = agent.address;
            if (!booking.managerName) {
              booking.managerName = agent.managerName;
            }
            return booking;
          }),
        );
      }

      return of(booking);
    }),
  );
};
